// 268: odkazy na dokumenty zakázky na disku firmy (SharePoint, OneDrive, Google Disk, Dropbox).
// Proyekty soubory nedrží — jen odkaz, práva hlídá disk firmy. Vzor: ProfitPilot lib/odkazy.js.

export const SLUZBY = {
  SHAREPOINT: { nazev: "SharePoint", zkratka: "SP", barva: "#0f7b8a" },
  ONEDRIVE: { nazev: "OneDrive", zkratka: "OD", barva: "#1f63c6" },
  GDRIVE: { nazev: "Google Disk", zkratka: "GD", barva: "#1b7a3e" },
  DROPBOX: { nazev: "Dropbox", zkratka: "DB", barva: "#2b52d6" },
  ODKAZ: { nazev: "Odkaz", zkratka: "URL", barva: "#6b6f76" },
};

/** Stejné rozpoznání jako backend (odkazy.sluzba). */
export function sluzba(url) {
  let host = "";
  try { host = new URL(/^https?:\/\//i.test(url || "") ? url : `https://${url}`).hostname.toLowerCase(); } catch { return "ODKAZ"; }
  if (host.endsWith("-my.sharepoint.com")) return "ONEDRIVE";
  if (host.endsWith("sharepoint.com")) return "SHAREPOINT";
  if (host.endsWith("onedrive.live.com") || host.endsWith("1drv.ms")) return "ONEDRIVE";
  if (host.endsWith("drive.google.com") || host.endsWith("docs.google.com")) return "GDRIVE";
  if (host.endsWith("dropbox.com") || host.endsWith("db.tt")) return "DROPBOX";
  return "ODKAZ";
}

export const infoSluzby = (urlOrKey) => SLUZBY[urlOrKey] || SLUZBY[sluzba(urlOrKey)] || SLUZBY.ODKAZ;

/** Podklad štítku služby — barva služby s průhledností, funguje ve světlém i tmavém režimu. */
export const podklad = (barva) => `${barva}1f`;

/** Jak získat odkaz — krátká nápověda pod polem. */
export const NAPOVEDA_ODKAZU =
  "SharePoint / OneDrive: Sdílet → Kopírovat odkaz → „Lidé ve vaší organizaci“. Google Disk: Sdílet → Kopírovat odkaz.";

export const krestni = (name) => (name || "").trim().split(/\s+/)[0] || name || "";
